import React from 'react';
import cx from 'classnames';
import styles from './marketoActivationView.module.scss';
import InputField from 'src/legacy/components/InputField';
import dateformat from 'dateformat';
import isEqual from 'is-equal';
import { toast } from 'react-toastify';
import _ from 'lodash';
import { 
    Form, FormGroup, InputGroup
  } from 'react-bootstrap';
import { localizedStrings } from 'src/localization/index.jsx';
import Toast from 'src/components/toast';
import SwitchButton from 'src/components/switchButton';

class MarketoActivationView extends React.Component {
  constructor(props){
    super(props);
    const integration = this.props.integration;

    this.state = {
        munchkinId: _.get(integration, 'configuration.munchkinId'),
        clientId: null,
        clientSecret: null,
        errors: null,
        syncReadAssetEvent: integration ? _.get(integration, 'configuration.syncReadAssetEvent') : true,
        syncReadConversationEvent: integration ? _.get(integration, 'configuration.syncReadConversationEvent') : true,
        syncReshareConversationEvent: integration ? _.get(integration, 'configuration.syncReshareConversationEvent') : true,
        syncLeadCreatedEvent: integration ? _.get(integration, 'configuration.syncLeadCreatedEvent') : true,
        syncAssetDownloadEvent: integration ? _.get(integration, 'configuration.syncAssetDownloadEvent') : true,
        syncLinkVisitedEvent: integration ? _.get(integration, 'configuration.syncLinkVisitedEvent') : true,
        syncEmailOpenEvent: integration ? _.get(integration, 'configuration.syncEmailOpenEvent') : true
    }

    this._handleAuthenticationClick = this._handleAuthenticationClick.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);
    this._toggleSwitchChange = this._toggleSwitchChange.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedMarketo = localizedStrings.components.integrations.marketo;
  }

  componentWillReceiveProps(nextProps) {
    if(!isEqual(this.props.integration && nextProps.integration)) {
      this.populateState(nextProps.integration)
    }
  }

  _handleFieldChange(field, e){
    let value =  e.target.value;
    this.setState({
      [field]: value,
    });
  }

  _handleAuthenticationClick(){
    this._validateForm();
    if(this.state.error){      
      return;
    }

    var configuration = {
      munchkinId : this.state.munchkinId,
      syncReadAssetEvent: this.state.syncReadAssetEvent,
      syncReadConversationEvent: this.state.syncReadConversationEvent,
      syncReshareConversationEvent: this.state.syncReshareConversationEvent,
      syncLeadCreatedEvent: this.state.syncLeadCreatedEvent,
      syncAssetDownloadEvent: this.state.syncAssetDownloadEvent,
      syncLinkVisitedEvent: this.state.syncLinkVisitedEvent,
      syncEmailOpenEvent: this.state.syncEmailOpenEvent
    }

    if(this.state.clientId){
      configuration['clientId'] = this.state.clientId;
    }

    if(this.state.clientSecret){
      configuration['clientSecret'] = this.state.clientSecret;
    }

    this.props.activateAccount(configuration).then((response) => {
      console.log(response);
      if(!response){
        return;
      }

      if(response.type === 'LEGACY_AUTHENTICATING_MARKETO_SUCCEDDED'){
        toast(
          <Toast.Sucess
            message = {this.localizedIntegrations.toast.marketo}      
          /> , {
            autoClose: 3000,
        }) 
        this.props.trackAdoptionMetricsForPluginConnectedEvent('Marketo')
      }else if(response.type === 'LEGACY_AUTHENTICATING_MARKETO_FAILED'){
        toast(
          <Toast.Failure
            message = {this.localizedMarketo.error_messages.failed_to_update}
          /> , {
            autoClose: 3000,
        })
      }
    });
  }

  _handleCancelClick(){
    this.setState({
        munchkinId : this.props.integration.configuration.munchkinId
    });
  }

  _validateForm(){
    var validationError = "";

    if(!this.props.integration && !this.state.munchkinId){
        validationError = this.localizedMarketo.error_messages.munchkin_id;
    }
    else if (!this.props.integration  && !this.state.clientId) {
      validationError = this.localizedMarketo.error_messages.client_id;
    }
    else if (!this.props.integration && !this.state.clientSecret) {
      validationError = this.localizedMarketo.error_messages.client_secret;
    }

    this.setState({
        error: validationError
    });
  }

  populateState(integration) {
    this.setState({
      munchkinId: integration.configuration.munchkinId,
      clientId: '',
      clientSecret: '',
      syncReadAssetEvent: this.state.syncReadAssetEvent,
      syncReadConversationEvent: this.state.syncReadConversationEvent,
      syncReshareConversationEvent: this.state.syncReshareConversationEvent,
      syncLeadCreatedEvent: this.state.syncLeadCreatedEvent,
      syncAssetDownloadEvent: this.state.syncAssetDownloadEvent,
      syncLinkVisitedEvent: this.state.syncLinkVisitedEvent,
      syncEmailOpenEvent: this.state.syncEmailOpenEvent
    })
  }

  _setClientIdPlaceholder() {
    if (this.props.integration && this.props.integration.configuration.munchkinId) {
      return `*************** ${this.localizedCommons.last_updated}: ${dateformat(this.props.integration.createdDate, 'dd mmm yyyy')}`;
    } else {
      return this.localizedMarketo.client_id_placeholder;
    }
  }

  _setClientSecretPlaceholder() {
    if (this.props.integration && this.props.integration.configuration.munchkinId) {
      return `*************** ${this.localizedCommons.last_updated}: ${dateformat(this.props.integration.createdDate, 'dd mmm yyyy')}`;
    } else {
      return this.localizedMarketo.client_secret_placeholder;
    }
  }

  _toggleSwitchChange(field){

    this.setState({
      [field]: !this.state[field]
    });
  }

  render(){
    return (
      <div className={styles.content}>
        <h1>{ this.localizedMarketo.activate.title }</h1>

        <div className={styles.form}>
          {this.state.error &&
            <p className={styles.errorMessage}>{this.state.error}</p>
          }

          <InputField 
            className={styles.field} 
            title={this.localizedMarketo.munchkin_id}
            placeholder={this.localizedMarketo.munchkin_id_placeholder}
            value = { this.state.munchkinId }
            onChange={this._handleFieldChange.bind(this, 'munchkinId')}
          />
          <InputField 
            className={cx(styles.field)} 
            title={this.localizedMarketo.client_id}
            placeholder={this._setClientIdPlaceholder()}
            value = {this.state.clientId}
            onChange={this._handleFieldChange.bind(this, 'clientId')}
          />
           <InputField 
            className={styles.field} 
            title={this.localizedMarketo.client_secret}
            placeholder={this._setClientSecretPlaceholder()}
            value = {this.state.clientSecret}
            onChange={this._handleFieldChange.bind(this, 'clientSecret')}
          />

            <FormGroup className={cx(styles.formGroup)}>
                <InputGroup>
                  <h5>{ this.localizedIntegrations.sync_events }</h5>
                </InputGroup>
              </FormGroup>
              <span className={styles.helpText}>{ this.localizedMarketo.configuration }</span>
              

              <FormGroup className={cx(styles.formGroup, styles.events)}>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.view_asset }</label>
                  <SwitchButton 
                    className={styles.switch}
                    id="syncReadAssetEvent"
                    checked={this.state.syncReadAssetEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncReadAssetEvent")} />
                </div>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.view_collection }</label>
                  <SwitchButton 
                    className={styles.switch}
                    id="syncReadConversationEvent"
                    checked={this.state.syncReadConversationEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncReadConversationEvent")} />
                </div>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.reshare_collection }</label>
                  <SwitchButton 
                    className={styles.switch}
                    id="syncReshareConversationEvent"
                    checked={this.state.syncReshareConversationEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncReshareConversationEvent")} />
                </div>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.create_lead }</label>
                  <SwitchButton 
                    className={styles.switch}
                    id="syncLeadCreatedEvent"
                    checked={this.state.syncLeadCreatedEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncLeadCreatedEvent")} />
                </div>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.download_asset }</label>
                  <SwitchButton 
                    className={styles.switch}
                    id="syncAssetDownloadEvent"
                    checked={this.state.syncAssetDownloadEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncAssetDownloadEvent")} />
                </div>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.opens_email }</label>
                  <SwitchButton 
                    className={styles.switch}
                    id="syncEmailOpenEvent"
                    checked={this.state.syncEmailOpenEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncEmailOpenEvent")} />
                </div>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.visits_link }</label>
                  <SwitchButton 
                    className={styles.switch}
                    id="syncLinkVisitedEvent"
                    checked={this.state.syncLinkVisitedEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncLinkVisitedEvent")} />
                </div>
            </FormGroup>

            <div className = {styles.alignment}>
                <button className={styles.button} onClick={this._handleAuthenticationClick} disabled={this.props.activating}>
                    {this.props.activating &&
                    `${this.localizedCommons.actions.saving_changes}...`
                    }
                    {!this.props.activating &&
                     this.localizedCommons.actions.save
                    }
                </button>
                <button className={cx(styles.button, styles.cancel)} onClick = { this._handleCancelClick } >
                  {this.localizedCommons.actions.cancel}
                </button>
            </div>
        </div>
      </div>
    );
  }
}

export default MarketoActivationView;